import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ShareTokenBaloonForm" })
export default class ShareTokenBaloonForm extends Vue {
    public localizer: any = Localizer;
    public isFormVisible: boolean = false;
    public isLoadingForm: boolean = false;
    public formData: any = { documentList: [], documentIdMasters: [], expirationDays: null };
    public expirationDays: any[] = [];
    public fileSharingDocuments: any[] = [];
    public validationErrors: any[] = [];

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get shareTokensDocumentIdMasters() {
        return this.$store.getters["myFileSharingStore/shareTokensDocumentIdMasters"];
    }

    get isShareTokenFormVisible() {
        return this.$store.getters["myFileSharingStore/isShareTokenFormVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isShareTokenFormVisible") async onShareTokenFormVisibleUpdate(newValue: boolean) {
        if (newValue) {
            await this.getData();
            document.body.classList.add("overflow");
            (<any>this).$refs.sharetokenform.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.sharetokenform.classList.remove("show");
        }
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingShareToken_GetBundleShareTokenData, { documentIdMasters: this.shareTokensDocumentIdMasters })).data;
        this.fileSharingDocuments = result.fileSharingDocuments;
        this.expirationDays = result.expirationDays;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.formData.documentIdMasters = this.shareTokensDocumentIdMasters;
        this.formData.expirationDays = !isNaN(Number(this.formData.expirationDays)) ? Number(this.formData.expirationDays) : 0;

        try {
            await Axios.post(this.routes.MyBremboPartsFileSharingShareToken_SaveShareToken, this.formData);

            this.$store.commit("myFileSharingStore/setShareTokenFormVisible", false);

            this.$store.dispatch("bremboToastStore/onAddToast", { message: this.localizer.get("App.FileSharing.ShareTokenBaloonCreatedSuccess"), type: "Success" });

            this.$store.commit("myFileSharingStore/setShareTokensDocumentIdMasters", []);
            this.$store.dispatch("myFileSharingStore/saveShareTokensDocumentIdMasters");

            this.formData = { documentList: [], documentIdMasters: [], expirationDays: null };

            GTagHelper.sendEvent("click", "filesharing_share", "submit");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public removeFile(documentIdMaster: string) {
        this.fileSharingDocuments = this.fileSharingDocuments.filter(x => x.value !== documentIdMaster);

        this.$store.commit("myFileSharingStore/setShareTokensDocumentIdMasters", this.shareTokensDocumentIdMasters.filter(x => x !== documentIdMaster));
        this.$store.dispatch("myFileSharingStore/saveShareTokensDocumentIdMasters");
    }

    public closeForm() {
        this.$store.commit("myFileSharingStore/setShareTokenFormVisible", false);
        this.formData = { documentList: [], documentIdMasters: [], expirationDays: null };
        this.fileSharingDocuments = [];
        this.validationErrors = [];
    }
}